import { inputs } from "../../../../inputs/inputConfigs";

export default {
  groups: [
    {
      items: [
        { input: inputs.noteHeadline, grid: { xs: 12 } },
        {
          input: inputs.noteDetail,
          grid: { xs: 12 },
        },
        { input: inputs.reason, grid: { xs: 12 } },
        { input: inputs.noteTime, grid: { xs: 12 } },
      ],
    },
  ],
};
